import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/search", label: "全站搜索" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系与反馈" },
];

export default function Footer() {
  const hotCategories = categories.slice(0, 6);

  return (
    <footer className="mt-16 w-full bg-primary-950 text-primary-100">
      <div className="grid grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4 lg:gap-10 lg:py-16">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className="ri-book-2-line text-xl" />
            </span>
            <span className="font-heading text-lg font-extrabold tracking-tight text-background-50">禁漫天堂</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-primary-200/80">
            专业的热门漫画下载门户，覆盖热血、恋爱、奇幻等十大类型，为漫画爱好者提供便捷的分类浏览、精准搜索与清晰的下载入口。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">
            <Link to="/" className="transition-colors hover:text-accent-400">快速导航</Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-primary-200/80 transition-colors hover:text-accent-400">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">
            <Link to="/category/rexue" className="transition-colors hover:text-accent-400">热门分类</Link>
          </h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm lg:grid-cols-2">
            {hotCategories.map((category) => (
              <li key={category.slug}>
                <Link to={`/category/${category.slug}`} className="flex items-center gap-1.5 text-primary-200/80 transition-colors hover:text-accent-400">
                  <i className={`${category.icon} text-xs`} />
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide text-background-50">
            <Link to="/about" className="transition-colors hover:text-accent-400">服务与声明</Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link to="/about" className="text-primary-200/80 transition-colors hover:text-accent-400">版权声明与资源来源</Link>
            </li>
            <li>
              <Link to="/about" className="text-primary-200/80 transition-colors hover:text-accent-400">访问说明</Link>
            </li>
            <li>
              <Link to="/contact" className="text-primary-200/80 transition-colors hover:text-accent-400">问题反馈</Link>
            </li>
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-primary-200/60">
            本站为前端交互演示站点，不提供任何实际文件下载，请支持正版渠道。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-900/60 px-4 py-5 md:px-6">
        <div className="flex flex-col items-center justify-between gap-3 text-xs text-primary-200/70 sm:flex-row">
          <p>© 2026 禁漫天堂 Manga Download. 仅供学习与演示使用。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-400" />
            尊重版权 · 支持正版 · 资源信息仅作演示
          </p>
        </div>
      </div>
    </footer>
  );
}